import { Autocomplete, Fade, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import { useSelector } from "react-redux";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import { MoreHoriz } from "@mui/icons-material";
import classes from './approval.module.css'
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import { emptyCheck } from "../../../utils/validations";

const VendorApprovalSlab = () => {


    const loginData = useSelector((state) => state.loginData.value);
    const [auth_token] = useState(loginData?.auth_token);
    const [user_token] = useState(loginData?.user?.token);


    const [getuserlist, setUserList] = useState([])
    const [departmentList, setDepartmentList] = useState([]);
    const [approvers, setApprovers] = useState([]);
    const [selectedApprovers, setSelectedApprovers] = useState([]);




    const [selectedDepartment, setSelectedDepartment] = useState(null);



    const [openapprovalmodal, setOpenApprovalModal] = useState(false)
    const [successpopup, setSuccessPopUp] = useState(false);

    const [stageName, setStageName] = useState({
        value: "",
        isValid: true,
    });


    const getAllUserList = async () => {
        try {
            const response = await axios.post(
                `${API_ENDPOINT.all_user_list}`,
                { buyer_token: user_token },
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );


            const filteredUsers = response?.data.filter(
                (user) => user.token !== user_token
            );

            setUserList(filteredUsers)
            setApprovers(filteredUsers)
        } catch (error) {
            console.error("Error fetching user list:", error);
        }
    };

    const getAllDepartment = async () => {
        try {
            const response = await axios.post(
                `${API_ENDPOINT.get_Department}`,
                { user_token: user_token },
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );
            setDepartmentList(response.data?.data || []);

        } catch (error) {
            console.error("Error fetching user list:", error);
        }
    };


    useEffect(() => {
        getAllUserList()
        getAllDepartment()
    }, [])



    const handleCloseModal = () => {
        setApprovers([])
        setOpenApprovalModal(false)
    }


    const viewUserHeading = (
        <HeaderTitle
            titleText={"Add Slab Range" || <MoreHoriz sx={{ fontSize: "30px" }} />}
            customclass={classes.heading_pop_pup}
        />
    );

    const viewTextActionButtons = [
        <DButtonOutlined
            label={"Cancel"}
            onClick={handleCloseModal}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
        />,
        <Dbutton
            label={'Submit'}
            // label={`${isEditMode ? 'Update' : 'Submit'}`}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
        // onClick={handleSavePOslab}
        // disabled={sendmsg && !errorMessages}
        />,
    ];

    const handleAddApprover = () => {
        const updated = [...approvers];
        if (updated.length > 0) {
            updated[updated.length - 1].showAdd = false;
        }
        updated.push({ id: approvers.length + 1, value: '', showAdd: true });
        setApprovers(updated);
    };

    const handleRemoveApprover = (id) => {
        const updated = approvers.filter(item => item.id !== id);
        if (updated.length > 0) {
            updated[updated.length - 1].showAdd = true;
        }
        setApprovers(updated);
    };

    const renderApproverInputs = () => {
        console.log(approvers)
        approvers.map((approver, index) => (
            <div key={approver.id} style={{ marginBottom: '1rem', display: 'flex', gap: '1rem' }}>
                <Autocomplete
                    disablePortal
                    options={getuserlist}
                    sx={{ width: 300 }}
                    getOptionLabel={(option) => `${option.first_name}-${option.designation || ''}`}
                    value={getuserlist.find(u => u.token === approver.value) || null}
                    onChange={(event, newValue) => {
                        const updated = [...approvers];
                        updated[index].value = newValue?.token || '';
                        setApprovers(updated);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={`Approver ${index + 2}`}
                            placeholder="Choose user"
                        />
                    )}
                />
                {approver.showAdd ? (
                    <Dbutton label="Add" onClick={handleAddApprover} btnHeight="3.5rem" />
                ) : (
                    <DButtonOutlined label="Remove" onClick={() => handleRemoveApprover(approver.id)} btnHeight="3.5rem" />
                )}
            </div>
        ));


    }


    const PoslabItemInputs = [
        <DTextInput
            label="Stage Name"
            type="text"
            maxLength={250}
            value={stageName.value}
            onChange={(e) => {
                let val = e.target.value;
                setStageName({
                    value: val,
                    isValid: emptyCheck(e.target.value),
                });
            }}
            error={!stageName.isValid}
            customClassName={classes.popupFields}
            errorMsg={"Stage Name is required"}
            size={"45%"}
        />,
        <Autocomplete
            disablePortal
            options={departmentList}
            getOptionLabel={(option) => option.name || ""}
            value={selectedDepartment}
            onChange={(e, newVal) => setSelectedDepartment(newVal)}
            sx={{ width: 230, m: 1 }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Department"
                    placeholder="Select department"
                    sx={{
                        '& .MuiInputBase-root': { fontSize: '14px' },
                        '& .MuiInputLabel-root': { fontSize: '14px' },
                        '& .MuiAutocomplete-tag': { fontSize: '12px' },
                    }}
                />
            )}
        />,
        <Autocomplete
            multiple
            disablePortal
            options={getuserlist}
            sx={{ width: 230, m: 1 }}
            getOptionLabel={(option) => {
                if (!option || typeof option !== 'object') return '';
                return `${option.first_name || 'N/A'} - ${option.designation || ''}`;
            }}

            value={selectedApprovers}
            onChange={(event, newValue) => setSelectedApprovers(newValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Approvers"
                    placeholder="Choose user(s) to approve"
                    sx={{
                        '& .MuiInputBase-root': { fontSize: '14px' },
                        '& .MuiInputLabel-root': { fontSize: '14px' },
                        '& .MuiAutocomplete-tag': { fontSize: '12px' },
                    }}
                />
            )}
        />,

        // <div>{renderApproverInputs()}</div>
    ]

    const OpenModal = () => {
        setOpenApprovalModal(true)
    }



    return (
        <div>
            <p>Arroval Slab</p>

            <Dbutton
                iconWidth="1rem"
                iconHeight="1rem"
                label="Supplier Approval Slab"
                btnHeight="4rem"
                onClick={OpenModal}
            />

            <Modal open={openapprovalmodal}
                closeAfterTransition
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
                sx={{
                    overflow: "auto",
                }}>
                <Fade>
                    <PopupFrame
                        poupHeading={viewUserHeading}
                        actionButtons={viewTextActionButtons}
                        inputChildren={PoslabItemInputs}
                    />
                </Fade>
            </Modal>
        </div>
    )
}

export default VendorApprovalSlab